import { APP_URL } from '@/config/links'
import { useLanguage } from '@/context/LanguageContext'
import {Truck} from 'lucide-react'

function AppPromo() {
  const { t } = useLanguage()
  const benefits = [t.appPromo.benefit1, t.appPromo.benefit2, t.appPromo.benefit3]

  return (
    <section className="relative z-10 bg-[#2b1c12] pt-16 pb-3">
      <div className="max-w-md mx-auto px-4">
        <a
          href={APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t.appPromo.cta}
          className="block rounded-2xl p-4 sm:p-5 border border-amber-400/45 bg-gradient-to-br from-[#5c3d22] via-[#4a3018] to-[#3a2414] shadow-[0_10px_28px_rgba(0,0,0,0.28)] hover:border-amber-300/70 transition-colors"
        >
          <div className="flex items-start justify-between gap-3 mb-2.5">
            <span className="inline-flex items-center rounded-full bg-amber-400 text-[#2b1c12] text-[10px] sm:text-[11px] font-bold tracking-wide px-2.5 py-1">
              {t.appPromo.badge}
            </span>
            <span className="w-9 h-9 rounded-xl bg-amber-400/15 border border-amber-400/30 flex items-center justify-center shrink-0">
              <Truck className="w-4 h-4 text-amber-300" aria-hidden="true" />
            </span>
          </div>

          <h2 className="text-amber-50 text-[1.35rem] sm:text-2xl font-extrabold leading-tight tracking-tight mb-2 whitespace-pre-line">
            {t.appPromo.title}
          </h2>

          <p className="text-amber-100/90 text-sm leading-snug mb-1.5">
            {t.appPromo.subtitle}
          </p>
          <p className="text-amber-100/70 text-xs leading-snug mb-3.5">
            {t.appPromo.support}
          </p>

          <span className="flex items-center justify-center w-full min-h-12 px-4 py-3 rounded-xl bg-amber-400 hover:bg-amber-300 text-[#2b1c12] font-extrabold text-[13px] sm:text-sm tracking-wide text-center leading-tight">
            {t.appPromo.cta}
          </span>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            {benefits.map((item) => (
              <li key={item} className="text-amber-200/85 text-[11px] font-medium leading-none">
                {item}
              </li>
            ))}
          </ul>
        </a>
      </div>
    </section>
  )
}

export default AppPromo
